import React from 'react';
import './PortfolioItem.css';

import { FiLink } from 'react-icons/fi';
import { FaSearchPlus } from 'react-icons/fa';

  
 
const PortfolioItem = ({id, image, title, category, link, index, popup}) => {
  
  return (
    <div className='portfolio-item' key={id}>
      <img src={image} alt='project image' />
      <div className='content'>
        <h4>{title}</h4>
        <p>{category}</p>
        <div className='btn-container'>
          <a href={link}><FiLink /></a> 
          <a onClick={() => {popup(index)}}><FaSearchPlus /></a> 
        </div>
      </div>
    </div>  
  )  
}

export default PortfolioItem;